import moment, { Moment } from "moment-timezone";
import { useEffect } from "react";
import ScheduleCalendarDatesHeaderItem from "./ScheduleCalendarDatesHeaderItem";

type ScheduleCalendarDatesHeaderProps = {
  selectedDate: Moment;
  viewingDate: Moment;
  onChangeViewingDate: (date: Moment) => void;
  compact?: Boolean;
  showDates?: Boolean;
  highlightSelectedDate?: Boolean;
};

export default function ScheduleCalendarDatesHeader(
  props: ScheduleCalendarDatesHeaderProps
) {
  const {
    selectedDate,
    viewingDate,
    onChangeViewingDate,
    showDates = true,
    compact = false,
    highlightSelectedDate = true,
  } = props;

  useEffect(() => {
    console.log("ScheduleCalendarDatesHeader: useEffect");
  }, [viewingDate]);

  const startOfTheWeek = moment(viewingDate).day(0);
  // The following will generate the 7 days of the week that the viewing date falls in.
  const dates = [...Array(7)].map((_, i) =>
    startOfTheWeek.clone().add(i, "day")
  );

  return (
    <>
      {dates.map((date, i) => (
        <ScheduleCalendarDatesHeaderItem
          date={date}
          // We are formatting the dates here in the comparison in order to compare only the date portion of the moment object without taking the time into consideration
          isSelected={
            !!highlightSelectedDate &&
            selectedDate.format("DD-MM-YYYY") === date.format("DD-MM-YYYY")
          }
          compact={compact}
          onChangeViewingDate={onChangeViewingDate}
          key={`${date} ${i}`}
          showDates={showDates}
        />
      ))}
    </>
  );
}
